<template>
  <el-dialog title="" :visible.sync="domVisible" :custom-class="dialogClass" :lock-scroll="false" :before-close="closeDialog" v-loading="loading">
    <div class="locationBox">{{$t('colon.shippingLocation')}}
      <el-select v-model="list.agencyId" @change="shippingFee()">
    <el-option
      v-for="item in options"
      :key="item.AreaId"
      :label="'From '+item.Nation"
      :value="item.AreaId">
    </el-option>
  </el-select>
</div>
    <el-scrollbar v-if="orderList">
      <div class="tab_dasap">
        <ul class="tab_dasap_ul">
          <li class="tab_dasap_title"><span>{{$t('base.weight')}}</span><span>{{$t('base.internationalShippingFee')}}</span></li>
          <li class="tab_dasap_title" v-for="(item,index) in orderList" :key="index">
            <span>{{ item.MinWeight > 0 ? item.MinWeight + 'kg' : item.MinWeight }} ~ {{ item.MaxWeight }}kg ({{ $t('base.included') }})</span>
            <span>{{areaSymbol}} {{ item.WeightFeeUSD }}</span>
          </li>
        </ul>
      </div>
    </el-scrollbar>
    <div class="weightBtn" v-if="orderList"><el-button type="primary" @click="closeDialog">{{$t('base.confirm')}}</el-button></div>
  </el-dialog>
</template>
<script>
import { getInfo } from "@/api/public";
export default {
  name: '',
  data() {
    return {
      userInfo:null,
      areaSymbol: this.$store.state.areaSymbol,
      loading: true,
      orderList: null,
      options:''
    }
  },
  props: {
    list: {},
    dialogClass: '',
    title: "",
    domVisible: Boolean,
  },
  watch: {},
  mounted() {},
  created() {
    this.userInfo = getInfo();
    this.GetAllAgency()
    if(this.userInfo != null){
      if(this.userInfo.MemberSource=="MO"){
            //this.areaSymbol="MOP"
          }
    }
    this.shippingFee()
  },
  methods: {

    // 获取办事处全部列表
    GetAllAgency() {
      let that = this
      //let data = { 'MemberId': that.userInfo.MappingUserId,"MemberSource":that.userInfo.MemberSource }
      that.$get(that.$interface.GetAll).then(res => {
        if (res.Result != 0) {
          var MemberSource='US'
          if(that.userInfo){
            MemberSource=that.userInfo.MemberSource
          }
          console.log(MemberSource,res.Data,'MemberSource')
          that.options=res.Data.filter(item=>{return item.AreaId!=MemberSource})
        }
      })
    },
    shippingFee() {
      let that = this
      let data = that.list
      that.loading=true
      this.$get(this.$interface.GetWeightList, data).then(res => {
        if (res.Result != 0) {
          that.orderList = res.Data
        } else {

        }
        that.loading = false;
      })
    },
    closeDialog() {
      this.$emit('closeDialog', 'weight', false)
    },
  },
  destroyed() {
    this.closeDialog()
  }
}

</script>
<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.tab_dasap {
  max-height: 50vh;
}

.alertWeightList .tab_dasap_ul li {
  display: flex;
  font-weight: 400;
}
.weightBtn{
  display: flex;
  justify-content: right;
  margin-top: 15px;
}
.locationBox{
  margin: 10px 0 30px;
}

</style>



// WEBPACK FOOTER //
// src/components/dialog/weight.vue